// EmailJs

// Template ID of the email
// export const TEMPLATE_ID = 'contact_form';
export const TEMPLATE_ID = 'emailjs_qradar';

// User ID of the account
export const USER_ID = 'user_6zdVICoJTCgMn7DTh94j9';

// Service ID of the service through which the email should be sent
export const SERVICE_ID = 'service_668c8va';
// SEND MAIL TO
export const SEND_TO = 'kuhrt@de.ibm.com';
// export const SEND_CC = 'SEND_CC@ywh.de';
export const SEND_BCC = 'santiago.ponton@ibm.com';
export const SEND_CC = 'qrsizest@ibm.com';

/*
## United States (US) ##
if pcountry==="US"
    if pstate ==="$state"
*/
export const US_MAILTO_ONE = 'Kendall.Graham@ibm.com'; // Kendall - AK, AZ, CO, HI, ID, NV, OR, WA, WY, GU, UM, AS
export const US_MAILTO_TWO = 'Reggie.Greer@ibm.com'; // Reggie - CA
export const US_MAILTO_THREE = 'ccrook@us.ibm.com'; // Carolyn - IA, KS, MN, MO, MT, NE, NM, ND, OK, SD
export const US_MAILTO_FOUR = 'ericjohnson1@ibm.com'; //  Eric - TX
export const US_MAILTO_FIVE = 'Marlena.Matthews@ibm.com'; // Marlena - AL, AR, FL, LA, MS, PR, VI
export const US_MAILTO_SIX = 'Gregory.Devieux@ibm.com'; // Gregory - GA, KY, NC, SC, OH, WV
export const US_MAILTO_SEVEN = 'maxwell.watkins@ibm.com'; // Maxwell - FED, DC, MD, VA, TN
export const US_MAILTO_EIGHT = 'Adib.Chowdury@ibm.com'; // Adib - NY
export const US_MAILTO_NINE = 'alicia.brandon@us.ibm.com'; // Alicia - IL, WI
export const US_MAILTO_TEN = 'Shawn.Reynolds@ibm.com'; // Shawn - CT, ME, MA, NH, RI, VT
export const US_MAILTO_ELEVEN = 'ozehmer@ibm.com'; //  Olivia - IN, MI, PA, MH, UT, MP, DE

/*
India OI / SDR: Kunal Shyam
Singapore OI / SDR: Surabhi Shrivastava
Australia OI / SDR: Sadhana A D
*/
export const INDIA_MAILTO = 'kunshyam@in.ibm.com'; // Kunal Shyam - IN
export const AUSTRALIA_MAILTO = 'Surabhi.Shrivastava@ibm.com'; // Sadhana A D - AU
export const SINGAPORE_MAILTO = 'Sadhana.A.D@ibm.com'; // Surabhi Shrivastava - SG
